import {
  ApproveSuccessAction,
  useConfirmApproveModal,
} from '@/features/approving_invoice_reports/components/ConfirmApproveModal/context/ConfirmApproveModalContext';
import {
  RejectSuccessAction,
  useConfirmRejectModal,
} from '@/features/approving_invoice_reports/components/ConfirmRejectModal/context/ConfirmRejectModalContext';
import { useTranslation } from '@/i18n';
import { ButtonGroup, ButtonV2 } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

export type HeaderButtonsProps = {
  is_report_approval: boolean;
  is_editable: boolean;
  is_approvable: boolean;
  reportId: string;
};

export const HeaderButtons: FC<HeaderButtonsProps> = memo(
  ({
    is_report_approval = false,
    is_editable = false,
    is_approvable = false,
    reportId,
  }) => {
    const { t } = useTranslation();
    const { onOpenConfirmRejectModal } = useConfirmRejectModal();
    const { onOpenConfirmApproveModal } = useConfirmApproveModal();
    const goToReportDetail = () => {
      window.location.href = `/approving_invoice_reports/${reportId}`;
    };

    const goToReportEdit = () => {
      window.location.href = `/approving_invoice_reports/${reportId}/edit`;
    };

    const renderButtons = () => {
      if (is_report_approval) {
        return (
          <>
            <ButtonV2 size='sm' isTertiary onClick={goToReportDetail}>
              {t('detail')}
            </ButtonV2>
            <ButtonV2
              isDisabled={!is_editable}
              size='sm'
              isSecondary
              onClick={goToReportEdit}
            >
              {t('edit')}
            </ButtonV2>
            <div className={cx('buttons-separator')} />

            <div className={cx('reject-approve-buttons')}>
              <ButtonV2
                size='sm'
                color='danger'
                isSecondary
                onClick={() =>
                  onOpenConfirmRejectModal(
                    reportId,
                    RejectSuccessAction.GOTO_NEXT_TARGET
                  )
                }
              >
                {t('approving_invoice_report.drawer.reject_button')}
              </ButtonV2>

              <ButtonV2
                isDisabled={!is_approvable}
                size='sm'
                color='primary'
                onClick={() =>
                  onOpenConfirmApproveModal({
                    reportTarget: reportId,
                    approveSuccessAction: ApproveSuccessAction.GOTO_NEXT_TARGET,
                  })
                }
              >
                {t('approving_invoice_report.drawer.approve_button')}
              </ButtonV2>
            </div>
          </>
        );
      }

      return (
        <ButtonV2 size='sm' isTertiary onClick={goToReportDetail}>
          {t('detail')}
        </ButtonV2>
      );
    };

    return <ButtonGroup>{renderButtons()}</ButtonGroup>;
  }
);
HeaderButtons.displayName = 'HeaderButtons';
